<template>
    <section class="section">
      <div class="d-flex flex-wrap align-items-stretch">
        <div class="col-lg-4 col-md-6 col-12 order-lg-1 min-vh-100 order-2 bg-white">
          <div class="p-4 m-3">
            <img v-bind:src="'src/assets/img/logo-efi.png'" alt="logo" width="100" class="shadow-light rounded-circle mb-5 mt-2">
            <h4 class="text-dark font-weight-normal">Welcome to <span class="font-weight-bold">EFI stocking tools</span></h4>
            <p class="text-muted">Before you get started, you must login or register if you don't already have an account.</p>
            <form method="POST" action="#" class="needs-validation" novalidate="">
              <div class="form-group">
                <label for="username">Username</label>
                <input id="username" type="text" v-model="username" class="form-control" name="email" tabindex="1" required autofocus>
                <div class="invalid-feedback">
                  Please fill in your username
                </div>
              </div>

              <div class="form-group">
                <div class="d-block">
                  <label for="password" class="control-label">Password</label>
                </div>
                <input id="password" v-model="password" type="password" class="form-control" name="password" tabindex="2" required>
                <div class="invalid-feedback">
                  please fill in your password
                </div>
              </div>

              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" name="remember" class="custom-control-input" tabindex="3" id="remember-me">
                  <label class="custom-control-label" for="remember-me">Remember Me</label>
                </div>
              </div>

              <div class="form-group text-right">
                <a href="auth-forgot-password.html" class="float-left mt-3">
                  Forgot Password?
                </a>
                <button @click="login()" type="submit" class="btn btn-primary btn-lg btn-icon icon-right" tabindex="4">
                  Login
                </button>
              </div>

              <div class="mt-5 text-center">
                Don't have an account? <a href="auth-register.html">Create new one</a>
              </div>
            </form>

            <div class="text-center mt-5 text-small">
              Copyright &copy; Eropa Fregance Indonesia
              <div class="mt-2">
                <a href="#">Privacy Policy</a>
                <div class="bullet"></div>
                <a href="#">Terms of Service</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-8 col-12 order-lg-2 order-1 min-vh-100 background-walk-y position-relative overlay-gradient-bottom" data-background="'./src/assets/img/unsplash/login-bg.jpg'">
          <div class="absolute-bottom-left">
            <div class="text-light p-5 pb-2">
              <div class="mb-5 pb-3">
                <h1 class="mb-2 display-4 font-weight-bold">Good Afternoon</h1>
                <h5 class="font-weight-normal text-muted-transparent">Bekasi, Indonesia</h5>
              </div>
              Photo by <a class="text-light bb" target="_blank" href="https://unsplash.com/photos/a8lTjWJJgLA">Justin Kauffman</a> on <a class="text-light bb" target="_blank" href="https://unsplash.com">Unsplash</a>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>

<script>

import axios from "axios";
import auth from "./Auth";
import router from '../../router/index.js';

export default {
  data() {
    return {
      username : '',
      password : '',
    }
  },
  mounted() {
    console.log('masuk ready');  
    this.isAuth = auth.authenticated
    window.jQuery('#userform').focus()
    if(auth.checkAuth()) {
      router.push({ name: 'Dashboard' })
    }else {
      // console.log('masuklogout');
      // auth.logout();
    }
  },
  methods: {
    login: function() {
      event.preventDefault();
      var login = new FormData();
      login.append('username',this.username);
      login.append('password',this.password);
      var kevin = auth.login(this,login,'Dashboard')
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/components/auth/Login.vue